import { ResizeGroupBase } from './ResizeGroup.base';

export const ResizeGroup = ResizeGroupBase;



// WEBPACK FOOTER //
// ../src/components/ResizeGroup/ResizeGroup.tsx